<template>
  <div class="dkb-page">
    <CCard>
      <CCardHeader class="dkb-head">
        <div>
          <strong>انتشار گروهی از دیجی‌کالا</strong>
          <div class="text-muted dkb-sub" v-if="job">{{ job.url }}</div>
        </div>
        <div>
          <span class="dkb-progress" v-if="items.length">{{ done_count }} از {{ items.length }} انجام شد - {{ ok_count }} موفق</span>
          <CButton color="danger" size="sm" class="mr-1" v-if="running" @click="stop = true">توقف</CButton>
          <CButton color="info" size="sm" class="mr-1" v-if="ok_count && !running" @click="copy_links()">کپی همهٔ لینک‌ها</CButton>
          <CButton color="dark" size="sm" class="mr-1" @click="$router.push('/dashboard/products/create')">بازگشت به افزودن محصول</CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <div v-if="!job" class="text-muted">
          هنوز انتشاری شروع نشده. از صفحهٔ «افزودن محصول» دکمهٔ «افزودن گروهی از جستجوی دیجی‌کالا» را بزنید.
        </div>
        <div class="dkb-maximg mb-2" v-if="job">
          <label class="ml-2 mb-0" for="dkb-max-images">تعداد عکس هر محصول</label>
          <input id="dkb-max-images" type="number" min="1" max="30" step="1" class="form-control form-control-sm d-inline-block" style="width:90px" v-model.number="max_images" :disabled="running" @change="save_max_images()">
        </div>
        <div v-if="status_text" class="dkb-status">
          <CSpinner v-if="loading_list" size="sm" color="primary" class="ml-2"/>
          {{ status_text }}
        </div>
        <table class="table dkb-table" v-if="items.length">
          <thead>
          <tr>
            <th style="width:40px">#</th>
            <th style="width:48px">وضعیت</th>
            <th>محصول</th>
            <th>لینک محصول در سایت</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(it, i) in items" :key="it.dk_id" :class="'is-' + it.state">
            <td class="text-muted">{{ i + 1 }}</td>
            <td class="dkb-state">
              <CSpinner v-if="it.state === 'working'" size="sm" color="primary"/>
              <span v-else-if="it.state === 'ok'" class="dkb-ok">✓</span>
              <span v-else-if="it.state === 'error'" class="dkb-err">✗</span>
              <span v-else-if="it.state === 'skip'" class="dkb-skip" title="تکراری">↷</span>
              <span v-else class="dkb-wait">•</span>
            </td>
            <td>
              <div>{{ it.title }}</div>
              <small class="dkb-err" v-if="it.error">{{ it.error }}</small>
              <small class="dkb-err" v-if="it.img_warn" :title="it.img_warn_detail">{{ it.img_warn }}</small>
              <CButton v-if="it.product_id && it.img_fails && it.img_fails.length" color="warning" size="sm" class="mr-1"
                       :disabled="!!it.img_retrying || running" @click="retry_images(it)">
                <CSpinner v-if="it.img_retrying" size="sm"/>
                دانلود مجدد عکس
              </CButton>
              <small class="text-muted d-block" v-if="it.state === 'skip'">تکراری؛ قبلاً در سایت ثبت شده</small>
            </td>
            <td class="dkb-links">
              <a v-if="it.site_link" :href="it.site_link" target="_blank" class="dkb-site" dir="ltr">{{ decodeURI(it.site_link) }}</a>
              <router-link v-if="it.product_id" :to="'/dashboard/products/edit/' + it.product_id" target="_blank">ویرایش</router-link>
            </td>
          </tr>
          </tbody>
        </table>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
function dkPrice(product) {
  // Digikala: rrp_price = list price, selling_price = actual price (both in Rial). Either may be missing.
  const v = (product && product.default_variant && product.default_variant.price) || {};
  const rrp = Number(v.rrp_price) || 0;
  const sell = Number(v.selling_price) || 0;
  const base = rrp || sell;
  return { price: base ? Math.round(base / 10) : '', off: sell && rrp && sell < rrp ? Math.round(sell / 10) : '' };
}
import axios from "@/api/http";
const JOB_KEY = 'dk_bulk_job';
const RESULT_KEY = 'dk_bulk_result';

export default {
  name: 'DigikalaBulkImport',
  data() {
    return {
      job: null,
      max_images: (() => { const n = parseInt(localStorage.getItem('dk_bulk_max_images'), 10); return n >= 1 && n <= 30 ? n : 5; })(),
      items: [],
      running: false,
      stop: false,
      loading_list: false,
      status_text: '',
    }
  },
  computed: {
    done_count() { return this.items.filter((x) => x.state === 'ok' || x.state === 'error' || x.state === 'skip').length; },
    ok_count() { return this.items.filter((x) => x.state === 'ok').length; },
  },
  mounted() {
    try { this.job = JSON.parse(localStorage.getItem(JOB_KEY) || 'null'); } catch (e) { this.job = null; }
    if (this.job && this.job.status === 'new') {
      this.job.status = 'running';
      localStorage.setItem(JOB_KEY, JSON.stringify(this.job));
      this.run();
    } else {
      try {
        const saved = JSON.parse(localStorage.getItem(RESULT_KEY) || '[]');
        this.items = saved.map((x) => (x.state === 'working' || x.state === 'waiting') ? Object.assign(x, {state: 'error', error: x.error || 'انجام نشد'}) : x);
      } catch (e) {}
    }
  },
  beforeDestroy() {
    this.stop = true;
  },
  methods: {
    sleep(ms) { return new Promise((r) => setTimeout(r, ms)); },
    async retry_images(it) {
      if (!it.product_id || !it.img_fails || !it.img_fails.length) return;
      this.$set(it, 'img_retrying', true);
      try {
        const fd = new FormData();
        fd.append('product_id', it.product_id);
        fd.append('urls', JSON.stringify(it.img_fails));
        fd.append('max_images', String(this.max_images));
        const r = await axios.post('/api/admin/product/digikala_retry_images', fd, {show_pros: false});
        const d = r.data || {};
        if (d.error == 1) throw new Error(d.msg || 'error');
        const left = d.image_failures || [];
        this.$set(it, 'img_fails', left.map((x) => x.url));
        if (left.length) {
          this.$set(it, 'img_warn', 'تصاویر ناموفق: ' + left.length);
          this.$set(it, 'img_warn_detail', left.map((x) => x.reason + ' ' + x.url).join('\n'));
        } else {
          this.$set(it, 'img_warn', '');
          this.$set(it, 'img_warn_detail', '');
        }
      } catch (e) {
        const msg = (e && e.response && e.response.data) ? this.error_text(e.response.data) : (e && e.message ? e.message : String(e));
        this.$set(it, 'img_warn_detail', msg);
      } finally {
        this.$set(it, 'img_retrying', false);
        this.persist();
      }
    },
    save_max_images() {
      const n = parseInt(this.max_images, 10);
      this.max_images = isNaN(n) ? 5 : Math.min(30, Math.max(1, n));
      localStorage.setItem('dk_bulk_max_images', String(this.max_images));
    },
    persist() { localStorage.setItem(RESULT_KEY, JSON.stringify(this.items)); },
    api_path(link, page) {
      const u = new URL(link.trim());
      const params = new URLSearchParams(u.search);
      params.set('page', page);
      const cat = u.pathname.match(/\/search\/category-([^/]+)/);
      if (cat) return '/dk-api/v1/categories/' + cat[1] + '/search/?' + params.toString();
      return '/dk-api/v1/search/?' + params.toString();
    },
    async dk_api(apiPath, query) {
      const fd = new FormData();
      fd.append('path', apiPath);
      fd.append('query', query || '');
      const res = await axios.post('/api/admin/product/digikala_api', fd, {show_pros: false});
      if (!res.data || res.data.error === 1) throw new Error((res.data && res.data.msg) || 'خطا در ارتباط با دیجی‌کالا');
      return res.data;
    },
    norm_name(name) {
      return String(name || '').replace(/[\u200c\s]+/g, ' ').replace(/ي/g, 'ی').replace(/ك/g, 'ک').trim().toLowerCase();
    },
    // existing products (by code = Digikala id, or same name) so duplicates are skipped
    async load_existing() {
      const res = await axios.post('/api/admin/product/get_products', new FormData(), {show_pros: false});
      const codes = {}, names = {}, slugs = {};
      ((res.data && res.data.items) || []).forEach((p) => {
        const name = (p.title && p.title.title) || p.name;
        if (p.code !== undefined && p.code !== null && p.code !== '') {
          const code = String(p.code).trim();
          codes[code] = p;
          codes[code.replace(/^dk-/i, '')] = p;
        }
        if (name) names[this.norm_name(name)] = p;
        if (p.title && p.title.slug) slugs[p.id] = p.title.slug;
      });
      return {codes, names, slugs};
    },
    async fetch_list(link, max) {
      const list = [];
      let page = 1, total_pages = 1;
      while (list.length < max && page <= total_pages && !this.stop) {
        const full = this.api_path(link, page).replace(/^\/dk-api/, '');
        const q = full.indexOf('?');
        const json = await this.dk_api(q >= 0 ? full.slice(0, q) : full, q >= 0 ? full.slice(q + 1) : '');
        const data = json.data || {};
        total_pages = (data.pager && data.pager.total_pages) || 1;
        (data.products || []).forEach((p) => {
          if (list.length < max && !list.find((x) => x.dk_id === p.id)) {
            list.push({dk_id: p.id, title: p.title_fa, state: 'waiting', error: '', product_id: null, site_link: ''});
          }
        });
        page++;
      }
      return list;
    },
    build_form(contents, dk_id) {
      const s = this.job.settings || {};
      const product = contents.data.product;
      const seo = contents.data.seo || {};
      const json_table = [];
      try { product.specifications[0].attributes.forEach((v) => json_table.push([v.title, v.values[0]])); } catch (e) {}
      // specs go to dk_specifications/properties only, never into the short description
      const text = {time: Date.now(), blocks: [], version: '2.28.2'};
      const full_text = {time: 1708248359501, blocks: [{id: 'DSM8JadA6h', type: 'paragraph', data: {text: (product.expert_reviews && product.expert_reviews.description) || '', alignment: 'right'}}], version: '2.28.2'};
      let price = '';
      const dkp = dkPrice(product); price = dkp.price;
      const fd = new FormData();
      try { product.images.list.forEach((v) => { if (Number(v.image_id) > 0) fd.append('post_images[]', v.image_id); }); } catch (e) {}
      fd.append('property_group_items', JSON.stringify(s.property_group_items || []));
      try { fd.append('dk_specifications', JSON.stringify(product.specifications || [])); } catch (e) {}
      const dkr = product.rating || {};
      fd.append('dk_id', String(dk_id));
      fd.append('source_url', 'https://www.digikala.com/product/dkp-' + dk_id + '/');
      if (dkr.rate != null) fd.append('dk_rating', dkr.rate > 5 ? Math.round(dkr.rate / 20 * 100) / 100 : dkr.rate);
      if (dkr.count != null) fd.append('dk_rating_count', dkr.count);
      fd.append('product_type', s.product_type);
      fd.append('cat_list', s.value_category || []);
      fd.append('tags', s.value_tags || []);
      if (Number(s.value_brand) > 0) fd.append('brand_id', s.value_brand);
      if (Number(s.value_label) > 0) fd.append('label_id', s.value_label);
      fd.append('name', product.title_fa);
      fd.append('url', '');
      fd.append('code', String(dk_id));
      fd.append('text', JSON.stringify(text));
      fd.append('full_text', JSON.stringify(full_text));
      fd.append('meta_desc', seo.description || '');
      fd.append('meta_title', seo.title || product.title_fa);
      fd.append('keyword', s.keyword || '');
      fd.append('price', price);
      fd.append('product_stock', s.product_stock || '');
      fd.append('order_point', s.order_point || 0);
      fd.append('product_off_price', typeof dkp !== 'undefined' ? dkp.off : '');
      fd.append('product_off_price_date', '');
      fd.append('selected_currency', s.selected_currency);
      return fd;
    },
    error_text(data) {
      if (!data) return 'پاسخ خالی از سرور';
      return data.msg || data.message || JSON.stringify(data).slice(0, 300);
    },
    async run() {
      const js = this.job.settings || {};
      if (!js.value_category || !js.value_category.length) { this.status_text = 'انتخاب دسته‌بندی محصول الزامی است'; return; }
      this.running = true;
      this.stop = false;
      this.loading_list = true;
      this.status_text = 'در حال خواندن لیست محصولات از دیجی‌کالا...';
      try {
        this.save_max_images();
        this.items = await this.fetch_list(this.job.url, Math.max(1, parseInt(this.job.max) || 1));
        this.persist();
        this.loading_list = false;
        this.status_text = this.items.length + ' محصول پیدا شد';
        const site = (localStorage.getItem('site_url') || '').replace(/\/+$/, '');
        const delay = Math.max(0, parseFloat(this.job.delay) || 0) * 1000;
        this.status_text = 'در حال بررسی محصولات تکراری...';
        let existing = {codes: {}, names: {}, slugs: {}};
        try { existing = await this.load_existing(); } catch (e) { console.log(e); }
        this.status_text = this.items.length + ' محصول پیدا شد';
        for (let i = 0; i < this.items.length; i++) {
          if (this.stop) break;
          const it = this.items[i];
          const dup = existing.codes[String(it.dk_id)] || existing.names[this.norm_name(it.title)];
          if (dup) {
            it.state = 'skip';
            it.product_id = dup.id;
            if (site && existing.slugs[dup.id]) it.site_link = site + '/product/' + existing.slugs[dup.id];
            this.persist();
            continue;
          }
          it.state = 'working';
          try {
            const fd = new FormData();
            fd.append('url', 'https://www.digikala.com/product/dkp-' + it.dk_id + '/');
            fd.append('download_image', this.job.download_image);
            fd.append('max_images', String(this.max_images));
            const imp = await axios.post('/api/admin/product/import_digikala', fd, {show_pros: false});
            const contents = imp.data;
            const fails = (contents && contents.image_failures) || [];
            if (fails.length) {
              it.img_warn = 'تصاویر ناموفق: ' + fails.length + ' از ' + (contents.image_total || '?');
              it.img_warn_detail = fails.map((x) => '#' + x.index + ' ' + x.reason + ' ' + x.url).join('\n');
              this.$set(it, 'img_fails', fails.map((x) => x.url));
              console.warn('Digikala image failures', it.dk_id, fails);
            }
            if (contents && contents.error == 1) throw new Error(contents.msg || 'خطا در دریافت از دیجی‌کالا');
            if (!contents || !contents.data || !contents.data.product || contents.data.product.is_inactive) {
              throw new Error('محصول در دیجی‌کالا قابل خواندن نیست');
            }
            const res = await axios.post('/api/admin/product/insert_product', this.build_form(contents, it.dk_id), {show_pros: false});
            if (res.data && res.data.error == 0) {
              it.product_id = res.data.id;
              existing.codes[String(it.dk_id)] = {id: res.data.id};
              existing.names[this.norm_name(it.title)] = {id: res.data.id};
              try {
                const info_fd = new FormData();
                info_fd.append('product_id', res.data.id);
                const info = await axios.post('/api/admin/product/get_product_info', info_fd, {show_pros: false});
                const slug = info.data.post.title.slug;
                if (site && slug) it.site_link = site + '/product/' + slug;
              } catch (e) {}
              it.state = 'ok';
            } else {
              it.state = 'error';
              it.error = this.error_text(res.data);
            }
          } catch (e) {
            it.state = 'error';
            it.error = (e && e.response && e.response.data) ? this.error_text(e.response.data) : (e && e.message ? e.message : String(e));
          }
          this.persist();
          if (i < this.items.length - 1 && delay && !this.stop) await this.sleep(delay);
        }
        this.status_text = this.stop ? 'متوقف شد' : 'پایان انتشار';
      } catch (e) {
        this.loading_list = false;
        this.status_text = 'خطا: ' + (e && e.message ? e.message : e);
      }
      this.items.forEach((x) => { if (x.state === 'waiting') x.state = 'error', x.error = 'انجام نشد (متوقف شد)'; });
      this.persist();
      this.job.status = 'done';
      localStorage.setItem(JOB_KEY, JSON.stringify(this.job));
      this.running = false;
    },
    copy_links() {
      const text = this.items.filter((x) => x.state === 'ok').map((x) => x.title + '\t' + (x.site_link || '')).join('\n');
      if (navigator.clipboard) navigator.clipboard.writeText(text);
    },
  }
}
</script>

<style scoped>
.dkb-head { display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 8px; }
.dkb-sub { font-size: 12px; direction: ltr; text-align: left; word-break: break-all; }
.dkb-progress { font-size: 13px; margin-left: 8px; color: #6e82a5; }
.dkb-status { margin-bottom: 12px; display: flex; align-items: center; gap: 6px; }
.dkb-table td { vertical-align: middle; }
.dkb-state { text-align: center; }
.dkb-ok { color: #16a34a; font-size: 18px; font-weight: 800; }
.dkb-err { color: #e85364; }
.dkb-state .dkb-err { font-size: 18px; font-weight: 800; }
.dkb-skip { color: #d97706; font-size: 18px; font-weight: 800; }
.dkb-wait { color: #c0c8d4; font-size: 18px; }
.dkb-links a { margin-left: 10px; white-space: nowrap; }
.dkb-site { font-size: 12px; white-space: normal !important; word-break: break-all; }
tr.is-working { background: rgba(17, 17, 17, .06); }
</style>
